import { Link } from "react-router-dom";

const NoAccount = () => (
    <div className="background d-flex align-items-center justify-content-center vh-100">
        <div className="text-center">
            <h1 className="display-1 fw-bold">404</h1>
            <p className="fs-3"> <span className=" text-app">Oops!</span> Account not found.</p>
            <p className="lead">
                The Account you’re looking for doesn’t exist.
            </p>
            <Link to={"/"} className="btn btn-app">Go Home</Link>
        </div>
    </div>

);

export default NoAccount;